import {Injectable} from '@angular/core';
import {AuthenticationService} from '@services/authentication.service';
import {BehaviorSubject, fromEvent, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectionStatusCheckerService {
  private _isOfflineSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isOffline$: Observable<boolean> = this._isOfflineSubject.asObservable();

  constructor(private authService: AuthenticationService) {
    fromEvent(window, 'online').subscribe(() => {
      console.log('Connection restored');
      this.authService.refreshAccessTokenIfNeeded();
      this._isOfflineSubject.next(false);
    });
    fromEvent(window, 'offline').subscribe(() => {
      console.log('Lost connection');
      this._isOfflineSubject.next(true);
    });
  }

}
